module.exports = __webpack_public_path__ + "static/Poster-c52960905cf0a020d0914a767875e783.png";